import { useIntlContext } from '../context/intl-context';
import { localizePath } from '../index';

export const useLocalizePath = (path, locale) => {
  if (!locale) throw Error('Locale is required to localize path');

  const intl = useIntlContext();

  return localizePath(path, locale, intl);
};
